import { Component, inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseViewComponent } from '../base-view.component';
import { StateChangedModel } from '../../common/services/state.service';
import { SecureDataService } from '../../common/services/securedata.sevice';
import { CreditCardBillingComponent } from '../payment-information-entry/credit-card-billing/credit-card-billing.component';
import { LanguageStateService } from '../../common/services/language-state.service';


@Component({
    selector: 'app-outstanding-balance',
    templateUrl: './outstanding-balance.component.html',
    styleUrl: './outstanding-balance.component.scss',
    standalone: false
})
export class OutstandingBalanceComponent extends BaseViewComponent {

  fb: FormBuilder = inject(FormBuilder)
  showCancelDialog = false;
  creditCardOutStandingForm: FormGroup;
  languageService: LanguageStateService = inject(LanguageStateService)
  expirationDateRaw = ''  // Stores the raw expiration date input value
  cardNumberRaw = ''  // Stores the raw card number input value
  isValidCard: boolean
  zipCodeRaw: any
  public cvvRaw: string = ''
  cardValidationStatus: boolean | null = null;
  cardType: number
  #secureDataService: SecureDataService = inject(SecureDataService);
  OutStandingBalance: string = '';
  paymentAuthorizationDialog = false;
  ServiceAvailabilityZipCode: string = ''
  PaymentZipMustMatchService = false

  @ViewChild('creditCardOutStandingBalance') creditCardOutStandingBalance: CreditCardBillingComponent;

  constructor() {
    super()
  }

  protected override refreshView(): void {
    this.creditCardOutStandingForm = this.fb.group({
      isConsentAgreed: [false, Validators.requiredTrue] // Add the checkbox control here
    })
  }



  protected override onSecureDataChanged(val: StateChangedModel): void {
    if (val) {
      const rawData = val.Data as any;
      if (rawData && typeof rawData == 'object') {
        this.OutStandingBalance = rawData['OutStandingBalance'];
        this.PaymentZipMustMatchService = rawData['PaymentZipMustMatchService'];
        this.ServiceAvailabilityZipCode = rawData['ServiceAvailabilityZipCode'];

      }

    }
  }



  onFormSubmit() {
    this.creditCardOutStandingBalance.creditCardForm.markAllAsTouched();
    this.creditCardOutStandingForm.markAllAsTouched();
    if (this.creditCardOutStandingBalance.creditCardForm.invalid || this.creditCardOutStandingForm.invalid) {
      return;
    }

    if (this.creditCardOutStandingBalance.creditCardForm.valid && this.creditCardOutStandingForm.valid) {
      this.#secureDataService.submitCustomerData({ ...this.creditCardOutStandingBalance.creditCardForm.value, cardNumber: this.creditCardOutStandingBalance.cardNumberRaw }, 'OutstandingBalance')
        .subscribe({
          next: () => {
            this.navigateWaiting();
          },
          error: (err) => {
            this.notificationService.showError(err);
          }
        });
    }

  }

  onFormCancel() {
    this.showCancelDialog = true;
    this.creditCardOutStandingBalance.creditCardForm.reset();
    this.creditCardOutStandingForm.reset();
  }

  onCancelPopUp(data: unknown) {
    console.log(data);
  }


}

